import { PDF_BORDER, ReportPage, ReportTable, Text } from '@/components';
import { ReportBatchTargetLabelModifier } from '@/features/mold/models';
import type { OrganizingTableFormat3Props } from '@/features/mold/utils/pdf/pdf-components-props';
import { useLocaledAmount } from '@/providers';
import type { FC } from 'react';

export const OrganizingTableFormat3: FC<OrganizingTableFormat3Props> = ({
  header,
  body,
  footer,
  organizationNames,
  dateByCreated,
  paperSize,
}) => {
  const { unit } = useLocaledAmount();
  return (
    <ReportPage
      title={{
        text: ReportBatchTargetLabelModifier['rs-report3'],
        variant: 'footnote',
      }}
      layout={{
        paperSize,
        orientation: 'landscape',
      }}
      caption={{
        unit,
        item: <Text weight="bold" variant="small" text={organizationNames} />,
      }}
      headerStyle={{ gap: 16 }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={body}
        footer={footer}
        defaultBorderStyle={PDF_BORDER.THIN}
        tableWidth="100%"
        borderColor="secondary"
      />
    </ReportPage>
  );
};
